<template lang="pug">
.v-swiper-slider.swiper-slider
	swiper.swiper-slider__slider(:modules="modules"
			:navigation="navigation"
			:pagination="pagination"
			:scrollbar="scrollbar"
			:followFinger="options.followFinger || true"
			:virtual="options.virtual || false"
			:initial-slide="options.initialSlide || 0"
			:breakpoints="options.breakpoints || null"
			:breakpointsBase="options.breakpointsBase || 'window'"
			:slides-per-view="options.slidesPerView || 1"
			:loop="options.loop || false"
			:space-between="options.spaceBetween || 20"
			:a11y="options.a11y"
			:effect="effect"
			:thumbs="thumbs"
			:slides-per-group="options.slidesPerGroup || 1"
			:cards-effect="cardsEffect"
			:allow-touch-move="allowTouchMove"
			@swiper="onSwiper"
			@init="onInit"
			@slide-change="onSlideChange")
		slot
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
// Swiper docs: https://swiperjs.com/vue
import {
	Navigation,
	Pagination,
	Scrollbar,
	A11y,
	EffectCards,
	Virtual,
	Thumbs
} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-cards';
import 'swiper/css/virtual';

export default {
	components: {
		Swiper,
		SwiperSlide
	},

	emits: [
		'slide-change',
		'swiper',
		'emit'
	],

	props: {
		options: {
			type: Object,
			default: null
		},

		thumbs: {
			type: Object,
			default: null
		},

		navigation: {
			type: [Boolean, Object],
			default: true
		},

		pagination: {
			type: Object,
			default: {
				el: null
			}
		},

		scrollbar: {
			type: Object,
			default: {
				el: null
			}
		},

		effect: {
			type: String, // may be "cards" or null
			default: null
		},

		// settings for cards effect
		cardsEffect: {
			type: Object,
			default: null
		},

		allowTouchMove: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			uniqueId: uniqueId('swiper-slider-'),
			swiper: null, // swiper instance
			modules: [
				Navigation,
				Pagination,
				Scrollbar,
				A11y,
				EffectCards,
				Thumbs,
				Virtual
			]
		};
	},

	methods: {
		onInit() {
			this.$nextTick(() => {
				this.$emit('emit');
			});
		},

		onSwiper(swiper) {
			this.swiper = swiper;
			this.$emit('swiper', this.swiper);
		},

		onSlideChange(e) {
			this.$emit('slide-change', e);
		},

		slideTo(index) {
			this.swiper.slideTo(index);
		},

		slideNext() {
			this.swiper.slideNext();
		},

		slidePrev() {
			this.swiper.slidePrev();
		}
	}
};
</script>